export const REDE = 'agente_rede';
